export default __webpack_public_path__ + "static/Travel-Like-A-Backpacker-ee4604c0acd726f833c6c25a955a0534.jpg";